import { useState } from 'react';
import { X } from 'lucide-react';
import { ChatPanel } from './chat/ChatPanel';

export const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="chat-widget-toggle"
        aria-label={isOpen ? 'Close chat' : 'Chat with Kasara'}
        className={`fixed bottom-6 right-4 sm:right-6 z-[60] w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.35)] hover:shadow-[0_0_40px_rgba(37,99,235,0.6)] hover:-translate-y-0.5 overflow-hidden ${
          isOpen ? 'bg-[#FFFFFF] border border-[#F29B3D]/40' : 'border-2 border-[#F29B3D]/60'
        }`}
      >
        {isOpen ? (
          <X className="w-5 h-5 text-[#A8631A]" />
        ) : (
          <>
            <img src="/kasara-avatar.jpg" alt="Kasara" className="w-full h-full object-cover" />
            <span className="absolute bottom-1 right-1 w-3 h-3 rounded-full bg-[#16A34A] border-2 border-[#1A2733] shadow-[0_0_6px_rgba(22,163,74,0.6)]" />
          </>
        )}
      </button>

      {isOpen && <ChatPanel />}
    </>
  );
};

export default ChatWidget;
